import React from "react";
import { Stack, Typography } from "@mui/material";

import { HubCardStack } from "../HubCardStack";
import { HubIcon } from "../HubIcon";

const DashboardEmptyState = ({
  icon = "Archive",
  title = "Nothing here yet",
  subtitle = "There's no activity in the current filter range.",
}) => (
  <HubCardStack alignItems="center" justifyContent="center">
    <HubIcon icon={icon} size="20px" sx={{ color: "hubColors.grey" }} />
    <Typography variant="boldCaption" fontSize={12}>
      {title}
    </Typography>
    <Typography
      variant="caption"
      fontSize={11}
      color="text.secondary"
      textAlign="center"
      maxWidth="320px"
    >
      {subtitle}
    </Typography>
  </HubCardStack>
);

export default DashboardEmptyState;
